module.exports = __webpack_public_path__ + "assets/img/正骨6.6c2d0227.jpg";